import { useMutation } from '@tanstack/react-query';
import { captureProfile, CaptureProfileRequest } from '../api/invitationApi';

/**
 * Mutation hook for capturing profile information.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useCaptureProfile() {
  return useMutation({
    mutationFn: ({
      invitationId,
      data,
    }: {
      invitationId: string;
      data: CaptureProfileRequest;
    }) => captureProfile(invitationId, data),
  });
}
